<template>
  <div id="app">
    <StarshipGame3D />
  </div>
</template>

<script>
import StarshipGame3D from './components/3dGame.vue';

export default {
  name: 'App',
  components: {
    StarshipGame3D,
  },
};
</script>